module.exports = __webpack_public_path__ + "img/icon-gift-loyalty.d148f4a6.svg";